// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bfm_a","ReactCrop--disabled":"bfm_b","ReactCrop--circular-crop":"bfm_c"};